const reportRegime: { [key: string]: any } = {
    MiFIR: 'Mifir',
    EMIR: 'Emir',
    ASIC: 'Asic',
    REFIT: 'Refit',
    MAS: 'Mas',
    IIROC: 'Iiroc',
    'ASIC Rewrite': 'AsicRewrite',
    'MAS Rewrite': 'MasRewrite',
    'OSC Rewrite': 'OscRewrite',
    SFTR: 'Sftr',
    'MiFIR Cb': 'MifirCb',
    'MiFIR Cp': 'MifirCp',
    'SIX Derivatives': 'SixDerivatives',
    'SIX Securities': 'SixSecurities',
    'MiFIR Transparency': 'MifirTransparency',
    CAT: 'Cat'
};

const reportRegimesWithoutDeprecated: { [key: string]: any } = {
    MiFIR: 'Mifir',
    REFIT: 'Refit',
    IIROC: 'Iiroc',
    'ASIC Rewrite': 'AsicRewrite',
    'MAS Rewrite': 'MasRewrite',
    'OSC Rewrite': 'OscRewrite',
    SFTR: 'Sftr',
    'MiFIR Cp': 'MifirCp',
    'SIX Derivatives': 'SixDerivatives',
    'SIX Securities': 'SixSecurities',
    'MiFIR Transparency': 'MifirTransparency',
    CAT: 'Cat'
};
export { reportRegime, reportRegimesWithoutDeprecated };
